import CustomWatermarkTutorial from 'components/Help/CustomWatermark/CustomWatermarkTutorial'

export default CustomWatermarkTutorial
